module.exports = __webpack_public_path__ + "img/signin-logo.115db04e.jpg";